import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { RegistreService } from '../registre.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';

@Component({
	selector: 'app-add-registre',
	templateUrl: './add-registre.component.html',
	styleUrls: ['./add-registre.component.scss']
})
export class AddRegistreComponent implements OnInit {
	errorTitle: string = environment.config.customNotifications.headers.error;
	errorIcon: string = environment.config.customNotifications.icons.error;
	errorType: string = environment.config.customNotifications.icons.error;
	helper = helper;

	token!: string;
	isLoading = false;
	// serieType$: any = [];

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };
    serieType: { id: string, name: string }[] = [
        this.defaultParameter,
        { 
            name: "Resetabilă anual",
            id:'1',  
        },
        { 
            name: "Numărătoare continuă",
            id:'2',  
        },
    ];

	form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]), // mppe
        slug_seq: new FormControl('', [Validators.required]),
        first_number: new FormControl('', [Validators.required]),
        serie_type: new FormControl('-1', [Validators.required, Validators.min(1)]),
        observatii: new FormControl(''),
	});

	constructor(private dialogRef: MatDialogRef<AddRegistreComponent>,
		private registreService: RegistreService,
		private notificationService: NotificationService,
		private authService: AuthService) {
		this.processToken();
	}

	ngOnInit(): void {
		// this.loadDocumentSerieType();
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.registreService.setToken(token);
		});
	}

	submitForm() {
		this.isLoading = true;

		const registre = {
			name: this.form.get('name')?.value,
			slug: this.form.get('slug')?.value,
			slug_seq: this.form.get('slug_seq')?.value,
			first_number: this.form.get('first_number')?.value,
			serie_type: this.form.get('serie_type')?.value,
			observatii: this.form.get('observatii')?.value,
		};
		this.registreService
			.addRegistre(registre)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: (res) => {
					this.dialogRef.close({ success: true });
				},
				error: (err) => {
					let errorMessage =
						environment.config.customNotifications.generalMessages.error;
					this.notificationService.warningSwal(
						this.errorTitle,
						errorMessage,
						this.errorIcon
					);
				},
			});
	}

	// loadDocumentSerieType() {
	// 	this.isLoading = true;
	// 	this.serieType$ = this.registreService
	// 		.getRecordsList()
	// 		.pipe(
	// 			map((results: any) => [this.defaultParameter, ...results]),
	// 			finalize(() => (this.isLoading = false)));
	// }
}
